// Modules
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { FormCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import SVG from 'components/widgets/icons/svg';
import WorkOrderForm from 'components/models/company/work-order-form';
import appHistory from 'app-history';
import WorkOrder from 'services/data/work-order';

import * as actions from '../store/actions';


export default function WatchAdd({ id }) {
  const { data: company } = actions.useCompany(id, { enable: !!id });
  const { refetch } = actions.useCompanyWorkOrders(id, { enable: !!id });

  const onSubmit = values => {
    const create = _.clone(values);

    return WorkOrder.create(create)
      .then(() => refetch())
      .then(() => {
        appHistory.push(`/companies/${company.id}/work-orders`);
      });
  };

  const initialValues = { date: moment().toDate(), company: company.id };

  return (
    <PageContent className="work-orders bg-medium-blue-grey">
      <div className="form-summary flex flex-equal-children">
        <FormCard className="work-order-form">
          <div className="form-header">
            <SVG src="svg/invoice-list.svg" className="work-order" />
            <h5 className="form-title">Add Work Order</h5>
          </div>
          <WorkOrderForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );
}
